/**
 * Copyright (c) 2021 - 2023, Kodit Doo
 * Created by kodit-marko on 03.01.2023.
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { IDokumentForPdvDto, PdvEvidencijeClient } from '@kodit/core/data-api';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { PdvEvidencijaPojedinacnaService } from '../../pojedinacna/pdv-evidencija-pojedinacna.service';

interface IRequest {
  searchValue: string;
}

@Component({
  selector: 'kodit-dokument-for-pdv-autocomplete',
  templateUrl: './dokument-for-pdv-autocomplete.html',
  styleUrls: ['./dokument-for-pdv-autocomplete.scss'],
})
export class DokumentForPdvAutocompleteComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription;

  /** Props */
  dokumentSuggestions: IDokumentForPdvDto[];
  dokumentSuggestionsStr: string[];
  form: FormGroupTypeSafe<IRequest>;

  /** I/O */
  @Input() formCtrlId: string;
  @Input() parentCtrl: string;
  @Input() dokumentCtrl: AbstractControl;
  @Input() shouldDisable: boolean = false;

  constructor(
    private _client: PdvEvidencijeClient,
    private _fb: FormBuilderTypeSafe,
    private _service: PdvEvidencijaPojedinacnaService
  ) {
    this._subs = new Subscription();
    this.dokumentCtrl = undefined!;
    this.dokumentSuggestions = [];
    this.dokumentSuggestionsStr = [];
    this.formCtrlId = 'dokument-for-pdv-autocomplete';
    this.parentCtrl = 'body';

    this.form = this._fb.group<IRequest>({
      searchValue: new FormControl(null, {
        validators: Validators.required,
      }),
    });
  }

  ngOnInit() {
    this.form.controls.searchValue.patchValue(this.dokumentCtrl.value.broj);
    this._setValidators();

    this._subs.add(
      this._service.getFormSaveClickedObject.subscribe((res) => {
        if (res) {
          if (this.form.invalid) {
            this.form.markAllAsTouched();
          }
        }
      })
    );
  }

  handleSearch(event: any) {
    if (this.form.value.searchValue.length < 1) {
      this.dokumentSuggestions = [];
      return;
    }
    // this._subs.add(
    //   this._client
    //     .getDokumentForPdvAutocomplete(this.form.value.searchValue)
    //     .subscribe((res) => {
    //       this.dokumentSuggestions = res.data!.responseList!;
    //       this.dokumentSuggestionsStr = res.data!.responseList!.map(
    //         (x) => x.broj!
    //       );
    //     })
    // );
  }

  handleSelectChange(dokumentStr: string) {
    const dokument = this.dokumentSuggestions.filter(
      (x) => x.broj === dokumentStr
    )[0];
    this._service.setDokument = dokument;
    this._service.setStranka = dokument.stranka;
    this._service.setUkupanIznos = dokument.ukupanIznos;
    this._service.setUkupanIznosNaknade = dokument.ukupanIznos;
    // this._service.setOsnovica10 = dokument.osnovica10 ?? 0;
    // this._service.setOsnovica20 = dokument.osnovica20 ?? 0;
    //this._service.setObracunatPdv = dokument.obracunatPdv ?? 0;
    this._service.setDatumPrometa = dokument.datumPrometa;
    this._service.setDatumValute = dokument.datumValute;
    this._service.setDatumAvansa = dokument.datumAvansa;
    this.dokumentCtrl.patchValue(dokument);
    this._removeValidators();
  }

  handleClear() {
    this.dokumentCtrl.reset();
    this._service.resetStranka();
    this._setValidators();
  }

  private _setValidators() {
    this.dokumentCtrl.setValidators(Validators.required);
    this.dokumentCtrl.updateValueAndValidity();
  }

  private _removeValidators() {
    this.dokumentCtrl.clearValidators();
    this.dokumentCtrl.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
